import clientSay1 from "images/Client1.avif";
import clientSay2 from "images/Client2.avif";
import clientSay3 from "images/Client3.avif";
import clientSay4 from "images/Client4.png";
import clientSay7 from "images/client7.avif";
import clientSay8 from "images/client8.avif";
import clientSay9 from "images/client9.avif";

export const globalJson = {
  prod_company_id: 525,
  dev_company_id: 525,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://Magnum-dev.1now.app",
  sender: "Magnum",
  ccEmail: "Magnum@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "Welcome to Magnum Auto Rentals At Magnum Auto Rentals, customer satisfaction is our top priority. We offer a wide array of reliable and well-maintained car brands to suit every occasion—from business trips to family vacations and everything in between. Located just 10 minutes from O’Hare International Airport in Chicago, we make it easy and convenient for you to pick up and drop off your rental with no stress. We take pride in providing dependable vehicles and exceptional service. Whether you’re booking for a day, a week, or longer, you can count on us for a smooth, professional rental experience. Returning customers enjoy generous discounts as a token of our appreciation for your loyalty. Let us earn your business—and your trust. Book with confidence at Magnum Auto Rentals.",

  clientSays_arr: [
    {
      id: 1,
      clientName: "Ade B.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "The host was very responsive and accommodating. The car was in excellent condition and very clean. I would lease again from them any day, any time. Top notch hospitality and easy pickup location. Overall 10 out of 10.",
      img: clientSay1,
    },
    {
      id: 2,
      clientName: "Mike K.",
      clientAddress: "LondDodge Grand Caravan 2019",
      content:
        "Funmilade was extremely communicative, accommodating, and helpful throughout the entire process. I encountered several issues with my flights on the way there—issues that would have likely caused problems with a standard rental company or other hosts. However, he went above and beyond to adjust to my changing itinerary, making the entire rental experience smooth and stress-free. I was able to rent the vehicle without any issues whatsoever, thanks to his flexibility and support. Will 100% be using him in the future for all of my trips to Chicago",
      img: clientSay2,
    },
    {
      id: 3,
      clientName: "Mario M.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "I would like to say that this car was absolutely amazing same with the host!, I needed a rental car for my road trip and the original car I was suppose to take I couldn’t since the host no showed! for pick up, drove from here all the way to Florida and back with no problems whatsoever the host did an amazing job with checking in on everything highly recommend",
      img: clientSay3,
    },
    {
      id: 4,
      clientName: "Austin J.",
      clientAddress: "Dodge Grand Caravan 2019",
      content: "Great car will definitely book again NO ISSUES",
      img: clientSay4,
    },
    {
      id: 5,
      clientName: "Ebonie M.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "The car was very clean and good on gas! The host was very helpful and responded very quickly whenever I had questions or concerns",
      img: clientSay4,
    },
    {
      id: 6,
      clientName: "Laura M.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "Host was great, flexible and helpful. I had the car for quite a while and he always helped me right away with any issues or questions. Already booking again. Car was good.",
      img: clientSay4,
    },
    {
      id: 7,
      clientName: "Eric M P.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "Amazing host I picked this car because I’m familiar with them, but also because the man is Nigerian and this is a family business and I support small businesses. He has a fleet of 50 cars with him and his wife and their two children. He also has an on-site porter, who also is his mechanic so if there are any issues, they are addressed immediately. He also keeps in constant communication, which is a key these days. Thank you very much for my first and best experience w/Turo I’ll definitely look at your vehicles first before looking at others based on location, price and customer service.",
      img: clientSay7,
    },
    {
      id: 8,
      clientName: "Alicia G.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "The truck is not a new car but it's not old either. It's a decent truck. Everything works good. Very good on gas since it's a 4 cylinder. It also has a great sound system.",
      img: clientSay8,
    },
    {
      id: 9,
      clientName: "Ayah A.",
      clientAddress: "Dodge Grand Caravan 2019",
      content:
        "Super nice people and reliable car",
      img: clientSay9,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/share/1QHYgozFtL/",
  instagram: "https://www.instagram.com/magnumcarrentals/",
  tiktok: "https://www.tiktok.com/@magnum.car.rental?_t=ZM-8xfwLZEmcD7&_r=1",

  //contact
  address: "2231 East Oakton Street\n Arlington Heights, IL 60005",
  workingHours: "",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone1: "+1 (224)-400-9505", //pending
  phone2: "+1 (224)-659-6285", //pending
  email: "magnumcarrental1@gmail.com", //pending
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
